module.exports = __webpack_public_path__ + "img/ma203.4861aed3.png";